// Снимок состояния страницы на время жизни вкладки браузера.
//
// Зачем. Keep-alive вкладки (components/tabs/TabsKeepAlive.js) переживают
// переключения, но НЕ переживают полную перезагрузку приложения. Gatsby делает её
// принудительно: node_modules/gatsby/cache-dir/navigation.js уходит в
// `window.location = pathname + search + hash`, если у загруженной страницы
// webpackCompilationHash не совпадает с window.___webpackCompilationHash — то есть
// при первой же навигации в открытой вкладке после каждого деплоя. Отменить это
// нельзя (иначе старый JS начнёт работать с данными новой сборки), поэтому делаем
// перезагрузку незаметной: тяжёлая таблица возвращается из снимка, а не с нуля.
//
// sessionStorage, а не localStorage: снимок живёт ровно столько, сколько живёт
// вкладка браузера — переживает reload и не протекает ни в другие вкладки, ни в
// следующий сеанс. Всё в try/catch: в приватном режиме доступ к хранилищу бросает.

const PREFIX = 'snapshot:';
// Верхняя планка на строку JSON. Реальный предел ставит браузер (квота
// sessionStorage), и QuotaExceededError ловится ниже — здесь только защита от
// заведомо бессмысленной сериализации гигантской таблицы.
const MAX_BYTES = 9000000;

const store = () => (typeof window === 'undefined' ? null : window.sessionStorage);

// Возвращает данные снимка или null (нет снимка, протух, битый, хранилище недоступно).
export const readSnapshot = (name, maxAgeMs) => {
  try {
    const s = store();
    if (!s) return null;
    const raw = s.getItem(PREFIX + name);
    if (!raw) return null;
    const snap = JSON.parse(raw);
    // Сравнение через "<" отсекает и NaN у битого savedAt.
    if (!snap || typeof snap !== 'object' || !(Date.now() - snap.savedAt < maxAgeMs)) {
      s.removeItem(PREFIX + name);
      return null;
    }
    return snap.data ?? null;
  } catch (e) {
    return null;
  }
};

// true — снимок записан. false — не записан (велик, квота, приватный режим): это
// не ошибка, страница просто останется без восстановления.
export const writeSnapshot = (name, data) => {
  try {
    const s = store();
    if (!s) return false;
    const payload = JSON.stringify({ savedAt: Date.now(), data });
    // Прежний снимок сносим в любом случае: иначе после отказа (таблицу развернули,
    // и она перестала влезать) перезагрузка вернула бы СТАРОЕ состояние — визуально
    // неотличимое от правильного восстановления.
    if (payload.length > MAX_BYTES) { s.removeItem(PREFIX + name); return false; }
    s.setItem(PREFIX + name, payload);
    return true;
  } catch (e) {
    try { store().removeItem(PREFIX + name); } catch (e2) { /* хранилище недоступно */ }
    return false;
  }
};

// Логаут: чужие таблицы не должны показываться следующему пользователю этой вкладки.
export const clearSnapshots = () => {
  try {
    const s = store();
    if (!s) return;
    Object.keys(s).filter((k) => k.startsWith(PREFIX)).forEach((k) => s.removeItem(k));
  } catch (e) {
    // хранилище недоступно — чистить нечего
  }
};
